export enum TellentDevFlag {
  UnifiedGroups = 'unified_groups',
  UnifiedDepartments = 'unified_departments',
  AppShell = 'app_shell',
  IntelligenceSettings = 'intelligence_settings',
  OneSettings = 'one_settings',
  OneDomain = 'one_domain',
  OneDomainSettings = 'one_domain_settings',
  UsersWithoutEmails = 'users_without_emails',
  GettingStartedTac = 'getting_started_tac',
  OnePositions = 'one_positions',
  TellentAssistant = 'tellent_assistant',
  ImportMembersCustomFields = 'import_members_custom_fields',
  OnePositionsSkillsImport = 'one_positions_skills_import',
  Scim = 'scim',
  AcquisitionBuyNowPayLater = 'acquisition_buy_now_pay_later',
  TeamMembersViews = 'team_members_views',
}

export type TellentDevFlagsMap = Record<TellentDevFlag, boolean>;

export type DevFlagsFetchResponse = {
  data: TellentDevFlag[];
};
